import { BmHttp } from "../utils/Global";

export const postRutina = async (rutina) => {
  try {

    const { data } = await BmHttp().post("create/rutina", rutina);
    return data;

  } catch (error) {
    console.error(error);
  }
};

export const getRutina = async () => {
  try {

    const { data } = await BmHttp().get("listar/rutina");
    return data;

  } catch (error) {
    console.error(error);
  }
};
